import { Col, Container, Row } from "react-bootstrap";

const Location = ({google_maps_link}) => {
	return (
		<Container fluid className="contact-page__location">
			<Row className="g-5">
				<Col lg="6" md="6" sm="12" xs="12" className="d-flex flex-column align-items-end">
					<iframe
						title="Google Map"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.9117080076603!2d55.307809225202945!3d25.273555377661957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f434f172c6d91%3A0x9e3a7738b9970e8f!2zTW9iaWxlIFBsYXphIEJ1aWxkaW5nIC0gMzgg2LTYp9ix2LkgLSDZodmoIC0g2K_Zitix2KkgLSDYr9io2Yo!5e0!3m2!1sar!2sae!4v1748515300928!5m2!1sar!2sae"
						style={{ border: "0" }}
						allowFullScreen=""
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					></iframe>
				</Col>
				<Col lg="6" md="6" sm="12" xs="12" className="d-flex flex-column align-items-start justify-content-center">
					<h2>Find us</h2>
					<p>
						Conviniently located for <br/> easy access to all major logistic location.
					</p>
					<button className="mt-2">
						<a
							target="_blank"
							rel="noreferrer"
							style={{ textDecoration: "none", color: "white" }}
							href={google_maps_link || "#"}
						>
							Get Direction
						</a>
					</button>
				</Col>
			</Row>
		</Container>
	);
};

export default Location;
